import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';
import service from '../service';
import type { ServiceCharge } from '@Types/toast';

type GetServiceChargesQuery = {
  name?: string;
};

type Params = {
  restaurantGuid: string;
  query?: GetServiceChargesQuery;
  enabled?: boolean;
};

export function useToastServiceCharges<
  TData = ServiceCharge[],
  TError = unknown,
>(
  { restaurantGuid, query, enabled = true }: Params,
  options?: Omit<
    UseQueryOptions<ServiceCharge[], TError, TData>,
    'queryKey' | 'queryFn' | 'enabled'
  >,
): UseQueryResult<TData, TError> {
  const queryResult = useQuery<ServiceCharge[], TError, TData>({
    queryKey: ['toastServiceCharges', restaurantGuid, query?.name ?? null],
    enabled: Boolean(restaurantGuid && enabled),
    queryFn: async () => {
      const res = await service.getServiceCharges(restaurantGuid, query ?? {});
      return (res ?? []) as ServiceCharge[];
    },
    ...(options as UseQueryOptions<ServiceCharge[], TError, TData>),
  });

  return queryResult;
}
